import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { addStoryRoute } from "../../routes/routesPath";
import { getFilters } from "../../utils/helpers";
import { myStoriesListingFilters } from "../../utils/filters";
import { defaultPage, limitOptions, sortingOptions } from "../../utils/constants";
import { isArray } from "../../utils/formatersAndParsers";
import { handleApiRequest } from "../../services/handleApiRequest";
import { getMyStoriesList } from "../../redux/stories/thunk";
import AskToShare from "../../Component/askToShare";
import MySelect from "../../Component/common/mySelect";
import MyPagination from "../../Component/common/pagination";
import StoryCard from "../../Component/storyCard/myStoryCard";
import ReactionsListsPop from "../../Component/Modals/reactionsListPop";
import LoadIndicator from "../../Component/Loader";
import CardSkeleton from "../../Component/skeleton/cardSkeleton";
import SortingDropdown from "../../Component/common/filters/sortingDropdown";
import FeelingsFilter from "../../Component/common/filters/feelingsFilter";

export default function MyStories() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedFilters = Object.fromEntries(searchParams.entries());

  const { myStoriesList = {}, loadingMyStories = false } = useSelector(
    (state) => state.stories || {}
  );

  const [userAction, setUserAction] = useState(null);
  const [paginationDetails, setPaginationDetails] = useState(defaultPage);

  const handleLimit = (value) => {
    setPaginationDetails((prev) => ({ ...prev, limit: value }));
    setSearchParams((prev) => {
      prev.set("limit", value);
      return prev;
    });
  };

  const handleStories = async () => {
    const filters = await getFilters(myStoriesListingFilters, selectedFilters);

    await handleApiRequest(getMyStoriesList, filters);
  };

  useEffect(() => {
    handleStories();
  }, [searchParams]);

  return (
    <>
      <div className="w-100 overflow-auto">
        {isArray(myStoriesList.records).length > 0 && (
          <div
            className={`${
              loadingMyStories ? "" : "hide-loader"
            } d-flex align-items-center justify-content-center`}>
            <LoadIndicator />
          </div>
        )}
        <div className="storyFilters d-flex align-items-center justify-content-start gap-2 p-3">
          <SortingDropdown sortingOptions={sortingOptions.slice(1)} />
          <FeelingsFilter className="pe-2" />
        </div>
        {myStoriesList.totalCount === 0 ? (
          <div className="text-center my-4 mt-lg-5">
            <h3 className="m-0">FeelingHub is just for you...</h3>
            <img src="/images/noStories.png" className="max-w-400 w-100" />
            <h4 className="text-uppercase">Post your first story</h4>
            <button
              className="primaryBtn rounded px-3 py-2"
              onClick={() => navigate(addStoryRoute)}>
              Express your Feeling
            </button>
          </div>
        ) : (
          <div className={`px-2 px-lg-3 pt-3`}>
            {myStoriesList.totalCount > 0 ? (
              <>
                {isArray(myStoriesList.records).map((story, i) => (
                  <StoryCard
                    key={story._id}
                    story={story}
                    handleReactionsList={setUserAction}
                    storyType="myStories"
                  />
                ))}
                <div className="d-flex justify-content-between py-3">
                  <div>
                    <MySelect
                      options={limitOptions}
                      isSearchable={false}
                      value={{ value: paginationDetails.limit, label: paginationDetails.limit }}
                      onChange={handleLimit}
                    />
                  </div>
                  <MyPagination
                    paginationDetails={paginationDetails}
                    setPaginationDetails={setPaginationDetails}
                    totalCount={myStoriesList.totalCount}
                    darkPagination={true}
                  />
                </div>
              </>
            ) : (
              Array.from({ length: 3 }).map((_, i) => <CardSkeleton key={i} />)
            )}
          </div>
        )}

        <div className="curvatureContainer">
          <div className="bg-white">
            <div id="curved-corner-topright" className="bg-white" />
          </div>
          <div className="bg-white">
            <div id="curved-corner-topleft" className="bg-white" />
          </div>
        </div>

        <AskToShare />
      </div>
      {userAction?.action === "showReactionsList" && (
        <ReactionsListsPop userAction={userAction} setUserAction={setUserAction} />
      )}
    </>
  );
}
